import React from "react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import MultipleSelect from "features/Admin/components/NewMultipleSelect";

const UrlForm = () => (
	<div>
		<Field type="text" name="urlCatalogExams" customlabel="URL du catalogue d'examens" component={CustomInputTextComponent} required />
		<Field type="text" name="urlTaking" customlabel="URL du manuel de prélèvement" component={CustomInputTextComponent} required />
		<Field type="text" name="lastUpdateCatalog" customlabel="Dernière mise à jour du catalogue" component={CustomInputTextComponent} />
	</div>
);

export default UrlForm;
